// extracted by mini-css-extract-plugin
export default {"column":"column--iDhGy8Hfqp","scrolling":"scrolling--rjSWf1vXhl","loader":"loader---JiDXbXRso"};